﻿export const TYPE_STANDARD_GENERAL = 'STANDARD_GENERAL';
export const TYPE_DYNAMIC_GENERAL = 'DYNAMIC_GENERAL';

export const SUBTYPE_GROUP = 'GROUP';
export const SUBTYPE_SEPARATOR = 'SEPARATOR';
export const SUBTYPE_PLUGIN = 'PLUGIN';
export const SUBTYPE_PRINTING = 'PRINTING';
export const SUBTYPE_SPATIAL_SEARCH = 'SPATIAL_ANALYSIS';
export const SUBTYPE_JS = 'JS';
export const SUBTYPE_PANEL = 'PANEL';
export const SUBTYPE_LEGEND = 'Legend';
export const SUBTYPE_SWIPE = 'Swipe';
export const SUBTYPE_ADD = 'ADD';
export const SUBTYPE_LIST = 'LIST';
export const SUBTYPE_ADD_MULTI = 'ADD_MULTI';
export const SUBTYPE_ZOOM = 'Zoom';
export const SUBTYPE_SCALE = 'ScaleControl';
export const SUBTYPE_CRS_SWITCHER = 'CoordinateReferenceSystemSwitcher';
export const SUBTYPE_MOUSE_POSITION = 'MousePosition';
export const SUBTYPE_NAVIGATION_TOOLBAR = 'NavigationToolbar';
export const SUBTYPE_SELECTION_TOOLBAR = 'SelectionTool';
export const SUBTYPE_EXPORT_TOOLBAR = 'ExportTool';
export const SUBTYPE_GEOLOCATION = 'Geolocation';
export const SUBTYPE_MEASUREMENT = 'MapMeasurement';
export const SUBTYPE_DIMENSIONING = 'MapDimensioning';
export const SUBTYPE_REDLINE = 'Redline';
export const SUBTYPE_JOIN_ANALYSIS = 'JoinAnalysis';
export const SUBTYPE_BUFFER_ANALYSIS = 'BufferAnalysis';
export const SUBTYPE_SPATIAL_INTERSECTION_ANALYSIS = 'SpatialIntersectionAnalysis';
export const SUBTYPE_COMPLEX_ANALYSIS = 'ComplexAnalysis';
export const SUBTYPE_DEFAULT_PRINT = 'SimpleMapPrint';
export const SUBTYPE_QUICK_ADD = 'QuickAdd';
export const SUBTYPE_TIMELINE = 'Timeline';
export const SUBTYPE_OVERVIEW = 'Overview';
export const SUBTYPE_FEATURE_INFORMATION = 'FeatureInformation';
